import keyBy from 'lodash/keyBy';
import { fromJS, Set } from 'immutable';
import { ADD_BANK, ADD_BANKS, SET_BANK_FILTERS, ARCHIVE_BANK, ASSOCIATE_ENTRIES, DISASSOCIATE_ENTRY, REMOVE_BANK } from '@instructure/quiz-common';
var addBanks = function addBanks(state, banks) {
  return state.mergeDeep(fromJS(keyBy(banks, 'id')));
};
var addBank = function addBank(state, payload) {
  return state.set(payload.id, payload.bank);
};
var setBankFilters = function setBankFilters(state, _ref) {
  var bankId = _ref.bankId,
    filters = _ref.filters;
  return state.setIn([bankId, 'filters'], filters);
};
var associateBankEntries = function associateBankEntries(state, bankId, bankEntryIds) {
  return state.updateIn([bankId, 'bankEntries'], function (entrySet) {
    var set = entrySet || Set();
    return set.union(bankEntryIds);
  });
};
var disassociateBankEntries = function disassociateBankEntries(state, bankId, bankEntryId) {
  return state.updateIn([bankId, 'bankEntries'], function (bankEntriesList) {
    return bankEntriesList.filter(function (item) {
      return item !== bankEntryId;
    });
  });
};
var defaultState = fromJS({});
export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : defaultState;
  var action = arguments.length > 1 ? arguments[1] : undefined;
  switch (action.type) {
    case ADD_BANKS:
      return addBanks(state, action.payload);
    case ADD_BANK:
      return addBank(state, action.payload);
    case SET_BANK_FILTERS:
      return setBankFilters(state, action.payload);
    case ASSOCIATE_ENTRIES:
      return associateBankEntries(state, action.payload.bankId, action.payload.bankEntryIds);
    case DISASSOCIATE_ENTRY:
      return disassociateBankEntries(state, action.payload.bankId, action.payload.bankEntryId);
    case REMOVE_BANK:
      return state.remove(action.payload);
    case ARCHIVE_BANK:
      return state.setIn([action.payload, 'archived'], true);
    default:
      return state;
  }
});